module.exports = __webpack_public_path__ + "static/img/copyIcon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copyIcon.png
// module id = 3jIG
// module chunks = 56